module.exports = __webpack_public_path__ + "static/media/IMG_020.e90635f2.JPG";